// extracted by mini-css-extract-plugin
module.exports =  {"root":"gCajcRYQ_sphj7DINgE_","instagramIndicator":"hwYSa6A5rxgoGuKznAsQ"};